import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';

const style = (theme) => ({
    dialogContent: {
        minWidth: 300,
    },
    miniAvatar: {
        backgroundColor: theme.palette.secondary.main,
        width: 20,
        height: 20,
        fontSize: 12,
    }
});

class ChooseSketchOrderFilterDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: props.open,
            statusFilterDialogOpen: false,
            organizationFilterDialogOpen: false,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.open !== this.props.open) {
            this.toggleDialog(this.props.open);
        }
    }

    toggleDialog = (open) => {
        this.setState({
            open,
        });
    };

    render() {
        const isV2EndpointUsed = !!(this.props.numberOfOwnerFilters);
        const isOwnerFilterDisabled = !!(this.props.numberOfRequesterFilters);

        return (
            <div>
                <Dialog open={this.state.open} fullScreen={this.props.fullScreen}>
                    <DialogTitle>
                        Filter By:
                    </DialogTitle>
                    <DialogContent className={this.props.classes.dialogContent}>
                        <List>
                            <ListItem button onClick={this.props.chooseStatusFilter} disabled={isV2EndpointUsed}>
                                <ListItemText primary="Status" />
                                {
                                    this.props.numberOfStatusFilters > 0 &&
                                    <Avatar className={this.props.classes.miniAvatar}>
                                        {this.props.numberOfStatusFilters}
                                    </Avatar>
                                }
                            </ListItem>
                            {
                                this.props.canFilterByOrganization &&
                                <ListItem button onClick={this.props.chooseOrganizationFilter} disabled={isV2EndpointUsed}>
                                    <ListItemText primary="Organization" />
                                    {
                                        this.props.numberOfOrganizationFilters > 0 &&
                                        <Avatar className={this.props.classes.miniAvatar}>
                                            {this.props.numberOfOrganizationFilters}
                                        </Avatar>
                                    }
                                </ListItem>
                            }
                            {
                                this.props.canFilterByRequester &&
                                <ListItem button onClick={this.props.chooseRequesterFilter} disabled={isV2EndpointUsed}>
                                    <ListItemText primary="Requester" />
                                    {
                                        this.props.numberOfRequesterFilters > 0 &&
                                        <Avatar className={this.props.classes.miniAvatar}>
                                            {this.props.numberOfRequesterFilters}
                                        </Avatar>
                                    }
                                </ListItem>
                            }
                            {
                                this.props.canFilterByOwner &&
                                <ListItem button onClick={this.props.chooseOwnerFilter} disabled={isOwnerFilterDisabled}>
                                    <ListItemText primary="Owner" secondary="This will disable all other filters" />
                                    {
                                        this.props.numberOfOwnerFilters > 0 &&
                                        <Avatar className={this.props.classes.miniAvatar}>
                                            {this.props.numberOfOwnerFilters}
                                        </Avatar>
                                    }
                                </ListItem>
                            }
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.props.onDismissClick}>
                            Dismiss
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

ChooseSketchOrderFilterDialog.propTypes = {
    open: PropTypes.bool,
    onDismissClick: PropTypes.func.isRequired,
    chooseStatusFilter: PropTypes.func.isRequired,
    chooseOrganizationFilter: PropTypes.func.isRequired,
    chooseRequesterFilter: PropTypes.func.isRequired,
    chooseOwnerFilter: PropTypes.func.isRequired,
    classes: PropTypes.shape({
        dialogContent: PropTypes.string.isRequired,
        miniAvatar: PropTypes.string.isRequired,
    }).isRequired,
    numberOfStatusFilters: PropTypes.number,
    numberOfOrganizationFilters: PropTypes.number,
    numberOfRequesterFilters: PropTypes.number,
    numberOfOwnerFilters: PropTypes.number,
    canFilterByOrganization: PropTypes.bool,
    canFilterByRequester: PropTypes.bool,
    canFilterByOwner: PropTypes.bool,
};

ChooseSketchOrderFilterDialog.defaultProps = {
    open: false,
    numberOfStatusFilters: 0,
    numberOfOrganizationFilters: 0,
    numberOfRequesterFilters: 0,
    numberOfOwnerFilters: 0,
    canFilterByRequester: false,
    canFilterByOwner: false,
};

export default withMobileDialog()(withStyles(style)(ChooseSketchOrderFilterDialog));
